import { render } from "./VendorDetailsHeader.vue?vue&type=template&id=3e3da9f8"
import script from "./VendorDetailsHeader.vue?vue&type=script&lang=js"
export * from "./VendorDetailsHeader.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__